























































import Vue, { PropType } from 'vue'
import Schedule from '@/types/Schedule.interface'
import ScheduleBuilderLine from '@/components/ScheduleBuilderLine.vue'
import moment from 'moment-timezone'
import Message from '@/types/Message.interface'
import { validateTimezone } from '@/utility/helpers'
export default Vue.extend({
    components: { ScheduleBuilderLine },
    props: {
        //  Applies the 'bold' style to the header
        bold: {
            type: Boolean,
            default: false
        },
        //  Applies the edit prop to each line
        edit: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        //  The array that holds the schedules
        schedules: {
            type: Array as PropType<Schedule[]>,
            required: true
        },
        //  Instructs the builder to offer only a single schedule
        single: {
            type: Boolean,
            default: false
        },
        // Lets the component know that Message Feed called this component and thus the styling needs to be slightly different
        messageFeed: {
            type: Boolean,
            default: false,
            required: false
        },
        // Takes the message data from the calling component to enable the ability to edit schedules
        message: {
            type: Object as PropType<Message>,
            required: false
        }
    },
    data() {
        return {
            //  Determines if the '28 day' warning is displayed
            warning: null
        }
    },
    mounted() {
        //  Validate the tenant's timezone
        validateTimezone()
    },
    computed: {
        addScheduleEnabled(): boolean {
            //  The button is NOT enable if component is 'read-only'
            if (this.readOnly) return false

            //  If the schedules array has no schedules, show the button
            if (this.schedules.length === 0) return true

            //  The button is NOT enabled if 'single' prop is set
            if (this.single) return false

            //  Else, default to enabled
            return true
        },
        barStyle(): object {
            const color = this.$colors.grey.base
            return {
                paddingTop: '5px',
                paddingBottom: '5px',
                borderTop: `1px solid ${color}`,
                borderLeft: `1px solid ${color}`,
                borderRight: `1px solid ${color}`,
                borderRadius: '10px 10px 0 0'
            }
        },
        contentStyle(): object {
            const color = this.$colors.grey.base
            return {
                border: `1px solid ${color}`,
                borderRadius: '0px 0px 10px 10px'
            }
        },
        titleStyle(): string {
            //  If the bold prop is set, return bold style
            if (this.bold) return 'subtitle-1 font-weight-medium'

            //  Else, return default style
            return 'grey--text text--darken-1 caption'
        }
    },
    methods: {
        addSchedule(): void {
            //  Create a new schedule
            const schedule = {
                next_send: null,
                interval: 'SEND ONCE'
            }

            //  Add the schedule
            this.schedules.push(schedule)

            //  Force the modal to update
            this.$forceUpdate()

            //  Emit change event
            this.$emit('change', this.schedules)
        },
        // Enables editing of schedules by using our put function to update the schedules date and time to send
        editSchedule(): void {
            /* We use the spread operator to combine the message object which contains the message, it's id, and other properties
            as well as the first item in the schedules object, (it will always be the first item as we can only edit one scheduled message at a time)
            we need the schedules object to get the interval property */
            const scheduleMessage = { ...this.message, ...this.schedules[0] }

            // We put these changes to our api which changes the timing of the scheduled message
            this.$store.dispatch('schedulesPut', scheduleMessage)

            // We close the dialog app that uses this workflow
            this.$store.dispatch('dialogClose', 'APP')
        },
        onScheduleChanged(): void {
            //  Create a list of intervals that require a special warning
            const special = ['MONTHLY', 'BIANNUALLY']

            //  Search for schedules that have a special 'interval' AND a 'day' greater than 28
            this.warning = this.schedules.find((x) => {
                const interval = special.includes(x.interval)
                const day = Number(moment(x.next_send).format('D')) > 28
                return interval && day
            })

            //  Send the 'change' event to the parent
            this.$emit('change')
        },
        //  Notify the user of disabled recurring dates
        popRecurringHelp(): void {
            //  Assemble the message
            const m = `Monthly, and Bi-Annual schedules are limited to the first 28 days of the month. <b>Schedules set to the 29th, 30th, or 31st of the month will default to the 28th.</b><br><br>Send Once, Daily, Weekly, and Annual schedules support the 29th - 31st of each month.`

            //  Pop the message dialog
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Disabled Recurring Dates',
                text: m,
                closeable: true
            })
        },
        removeSchedule(index: number): void {
            this.schedules.splice(index, 1)

            //  If the schedules array is now empty, set it to null
            if (this.schedules.length === 0) this.$emit('reset')

            //  Emit change event
            this.$emit('change', this.schedules)

            //  Force the list of ScheduleBuilderLines to update
            this.$forceUpdate()
        }
    }
})
